import { useEffect, useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import Loader from "../../../components/loader";
import UiButton from "../../../components/button";
import TextInput from "../../../components/textinput/TextInput";
import ERC20ABI from "../../../utils/abi/ERC20.json";
import {
  useSupportedTokens,
  useSecurityTokenDetails,
  useNetworkOptions,
  useIntermediaryList,
  useCustodianData,
} from "../../../context/contractDataLoaderService";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { shortAddress } from "../../../components/common/CommonHeader";
import {
  SecuritiesFactory,
  contractAddress,
  Security,
} from "@verified-network/verified-sdk";
import { signMessage, NULL_ADDRESS } from "../../../utils/response";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  countryList,
  getCountryName,
  getCountryCode,
  productCategory,
  networks,
  MarginIssueCategoryMarkers,
  countryDetails,
  supportedCountries,
  AssetsEchanges,
  auth,
} from "../../../utils/constants";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import { ethers, providers } from "ethers";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../../utils/helpers/networks";
import { useGlobal } from "../../../context/globalContext";
import {
  convertBytes32ToIpfsHash,
  convertIpfsHashToBytes32,
  fetchAllNSDQAssets,
  getAllVerifiedCashBalances,
} from "../../../utils/helpers";
import { create } from "ipfs-http-client";

function NewIssue(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const [showModal, setShowModal] = useState(false);
  let { data: securityTokens } = useSecurityTokenDetails();
  const productType = ["Qualified", "Retail"];
  const { data: networkOptions } = useNetworkOptions();

  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(null);
  const [issuer, setIssuer] = useState("");
  let { data } = useSupportedTokens();
  const [country, setCountry] = useState("");
  const [existingSecurityAddress, setExistingSecurityAddress] = useState("");
  const [countryName, setCountryName] = useState("");
  let { data: intermediaryList } = useIntermediaryList(country, "DP");
  const [selectedCurrencyToken, setSelectedCurrencyToken] = useState(null);
  const [restrictedCountries, setRestrictedCountries] = useState([]);
  const [showCustodian, setShowCustodian] = useState(false);
  const [custodian, setCustodian] = useState(null);
  const { data: custodianList } = useIntermediaryList(country, "Custodian");
  const [clickAssestExchange, setClickAssestExchange] = useState("nsdq");
  const [allAssets, setAllssets] = useState([]);
  const [allAssetsAmex, setAllssetsAmex] = useState([]);
  const [allAssetsNsaqot, setAllssetsNsaqot] = useState([]);
  const [allAssetsNyse, setAllssetsNyse] = useState([]);
  const [uderlyingAsset, setUderlyingAsset] = useState({
    name: "",
    id: "",
  });
  const [ipfsDoc, setIpfsDoc] = useState("");
  const abiCoder = new ethers.utils.AbiCoder();
  const { data: custodianData } = useCustodianData(custodian);
  const currencyList = custodianData?.map((data) => {
    return {
      tokenAddress: data.issueCurrencyAddress,
      tokenName: data.issueCurrency,
    };
  });

  let currencySupportedList;
  if (data) {
    currencySupportedList = [...data?.filter((token) => !token.isFiat)];
    if (currencyList) {
      currencySupportedList.push(...currencyList);
    }
  }

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    clickAssestExchange === "nsdq"
      ? allAssets.slice(indexOfFirstItem, indexOfLastItem)
      : clickAssestExchange === "amex"
        ? allAssetsAmex.slice(indexOfFirstItem, indexOfLastItem)
        : clickAssestExchange === "nsdqot"
          ? allAssetsNsaqot.slice(indexOfFirstItem, indexOfLastItem)
          : clickAssestExchange === "nyse"
            ? allAssetsNyse.slice(indexOfFirstItem, indexOfLastItem)
            : [];
  const totalPages =
    clickAssestExchange === "nsdq"
      ? Math.ceil(allAssets.length / itemsPerPage)
      : clickAssestExchange === "amex"
        ? Math.ceil(allAssetsAmex.length / itemsPerPage)
        : clickAssestExchange === "nsdqot"
          ? Math.ceil(allAssetsNsaqot.length / itemsPerPage)
          : clickAssestExchange === "nyse"
            ? Math.ceil(allAssetsNyse.length / itemsPerPage)
            : 0;

  useEffect(() => {
    let cancelled = false;

    const handleExternalAssets = async () => {
      setAllssets([]);

      const firstRes = await fetchAllNSDQAssets(0);

      if (!firstRes?.docs || cancelled) return;

      setAllssets((prev) => [...prev, ...firstRes.docs]);

      const total = Number(firstRes.numFound);
      const totalPages = Math.ceil(total / 200);

      for (let page = 1; page < totalPages; page++) {
        if (cancelled) break;

        const res = await fetchAllNSDQAssets(page);

        if (!res?.docs?.length) break;

        setAllssets((prev) => [...prev, ...res.docs]);
      }
    };

    handleExternalAssets();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (props.intermediary) {
      if (props.intermediary.address.toLowerCase() === account.toLowerCase())
        setShowCustodian(true);
      else setShowCustodian(false);
    }
  }, [props.intermediary]);
  let factoryContract, securityContract;
  if (provider && provider.getSigner && chainId && address) {
    factoryContract = new SecuritiesFactory(
      signer,
      contractAddress[chainId].SecuritiesFactory,
    );
  }

  const addIssue = async () => {
    if (props.companyName.length == 0) {
      toast.error(FailureToast("", "Enter Security name"), ToastOptions);
      return;
    } else if (props.existingIssue && existingSecurityAddress.length == 0) {
      toast.error(FailureToast("", "Enter Security address"), ToastOptions);
      return;
    } else if (props.companyName.length > 32) {
      toast.error(
        FailureToast("", "Keep security name length < 32"),
        ToastOptions,
      );
      return;
    } else if (props.isinValue.length == 0) {
      toast.error(FailureToast("", "Enter security symbol"), ToastOptions);
      return;
    } else if (props.currency == "Select Currency") {
      toast.error(FailureToast("", "Select currency to pair"), ToastOptions);
      return;
    } else if (props.productType == "Select type") {
      toast.error(FailureToast("", "Select product type"), ToastOptions);
      return;
    } else if (props.productCategory == "Select category") {
      toast.error(FailureToast("", "Select product category"), ToastOptions);
      return;
    } else if (country.length == 0) {
      toast.error(FailureToast("", "Select issuer country"), ToastOptions);
      return;
    } else if (amount <= 0) {
      toast.error(FailureToast("", "Select proper amount"), ToastOptions);
      return;
    }

    const productCategory = ethers.utils.formatBytes32String(
      props.productCategory,
    );
    const issuingCountry = ethers.utils.formatBytes32String(country);
    const restrictedCountryList = restrictedCountries.map((countryName) => {
      if (countryName.code !== "") {
        return ethers.utils.formatBytes32String(countryName.code);
      }
    });

    let tickerId;

    if (uderlyingAsset?.id) {
      tickerId = "GTN:" + uderlyingAsset?.id;
    }

    const restrictedCountryFmt = tickerId
      ? [...restrictedCountryList, ethers.utils.formatBytes32String(tickerId)]
      : restrictedCountryList;
    const restrictedCountryListEncoded = abiCoder.encode(
      ["bytes32[]"],
      [restrictedCountryFmt],
    );
    setLoading(true);
    let isIssued = false;
    let securityAddress;
    try {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await factoryContract._getMeeQuote(
          cashTokens[0]?.address,
          "issueSecurity",
          [
            props.existingIssue ? existingSecurityAddress : NULL_ADDRESS,
            productCategory,
            props.companyName,
            props.isinValue,
            selectedCurrencyToken.tokenAddress,
            account,
            props.intermediary.address,
            restrictedCountryListEncoded,
            issuingCountry,
            props.productType == "Qualified" ? 1 : 0,
          ],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }

      await factoryContract
        .issueSecurity(
          props.existingIssue ? existingSecurityAddress : NULL_ADDRESS,
          productCategory,
          props.companyName,
          props.isinValue,
          selectedCurrencyToken.tokenAddress,
          account,
          props.intermediary.address,
          restrictedCountryListEncoded,
          issuingCountry,
          props.productType == "Qualified" ? 1 : 0,
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {},
        )
        .then((res) => {
          if (res?.status === 0) {
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(SuccessToast(transactionLink), ToastOptions);
            isIssued = true;
          } else {
            setLoading(false);
            toast.error("Transaction Failed", ToastOptions);
            return;
          }
        });
      const response = await factoryContract.getIssues();
      securityAddress = response.response.result.at(-1);
      const securityAdd = response.response.result.at(-1);

      if (showCustodian && custodian) {
        let paymentToken;

        if (
          verifiedWalletDetails &&
          Object?.keys(verifiedWalletDetails)?.length > 0
        ) {
          const cashTokens = await getAllVerifiedCashBalances(
            chainId,
            web3,
            account,
          );

          if (!cashTokens || cashTokens?.length === 0) {
            setLoading(false);
            toast.error(
              "No valid Cash Token on this network. Change network and try again.",
              ToastOptions,
            );

            return;
          }
          paymentToken = cashTokens[0];
          const txQuote = await factoryContract._getMeeQuote(
            cashTokens[0]?.address,
            "setCustodian",
            [securityAdd, account, custodian],
          );

          if (
            Number(cashTokens[0]?.balance) === 0 ||
            Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
          ) {
            setLoading(false);
            toast.error(
              `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
              ToastOptions,
            );

            return;
          }
        }

        await factoryContract
          .setCustodian(
            securityAdd,
            account,
            custodian,
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                }
              : {},
          )
          .then((res) => {
            if (res?.status === 0) {
              const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
              toast.success(SuccessToast(transactionLink), ToastOptions);
            } else {
              toast.error("Transaction Failed", ToastOptions);
              return;
            }
          });
      }

      setLoading(false);
    } catch (err) {
      let error = { err };
      console.log(error);
      const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
      setLoading(false);
      toast.error(FailureToast(transactionLink), ToastOptions);
    }
    setLoading(true);

    if (isIssued && securityAddress) {
      props.updateSecurity(securityAddress);
      if (!props.existingIssue) {
        try {
          let paymentToken;

          if (
            verifiedWalletDetails &&
            Object?.keys(verifiedWalletDetails)?.length > 0
          ) {
            const cashTokens = await getAllVerifiedCashBalances(
              chainId,
              web3,
              account,
            );

            if (!cashTokens || cashTokens?.length === 0) {
              setLoading(false);
              toast.error(
                "No valid Cash Token on this network. Change network and try again.",
                ToastOptions,
              );

              return;
            }
            paymentToken = cashTokens[0];
            const txQuote = await factoryContract._getMeeQuote(
              cashTokens[0]?.address,
              "addBalance",
              [
                securityAddress,
                NULL_ADDRESS, //transferor
                account, //transferee
                web3.utils.toWei(amount, "ether"),
              ],
            );

            if (
              Number(cashTokens[0]?.balance) === 0 ||
              Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
            ) {
              setLoading(false);
              toast.error(
                `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
                ToastOptions,
              );

              return;
            }
          }

          await factoryContract
            .addBalance(
              securityAddress,
              NULL_ADDRESS, //transferor
              account, //transferee
              web3.utils.toWei(amount, "ether"), //amount
              paymentToken?.address
                ? {
                    paymentToken: paymentToken?.address,
                    apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                  }
                : {},
            )
            .then((res) => {
              setLoading(false);
              if (res?.status === 0) {
                const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
                toast.success(SuccessToast(transactionLink), ToastOptions);
                props.updateModalView(2);
              } else {
                toast.error("Transaction Failed", ToastOptions);
              }
            });
        } catch (err) {
          let error = { err };
          console.log(error);
          const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
          setLoading(false);
          toast.error(FailureToast(transactionLink), ToastOptions);
        }
      } else {
        props.updateExistingModalView(2);
      }
    }
  };

  return (
    <>
      <ToastContainer />
      {loading ? <Loader /> : null}
      <div className="d-grid gap-2">
        <Row className="ml-1 align-items-center">
          {props.existingIssue && (
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Security Address</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <TextInput
                  placeholder="Security Address"
                  required
                  value={existingSecurityAddress}
                  onChange={async (e) => {
                    setExistingSecurityAddress(e.target.value);
                    if (e.target?.value?.length === 42) {
                      const tokenContract = new web3.eth.Contract(
                        ERC20ABI,
                        e.target.value,
                      );
                      const name = await tokenContract.methods.name().call();

                      props.updateCompanyName(
                        name?.replace(/\0/g, "")?.substring(0, 31),
                      );
                      const symbol = await tokenContract.methods
                        .symbol()
                        .call();

                      props.updateIsinValue(
                        symbol?.replace(/\0/g, "")?.substring(0, 31),
                      );
                    } else {
                      props.updateCompanyName("");
                      props.updateIsinValue("");
                    }
                  }}
                />
              </Col>
            </Row>
          )}
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Security Name</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Name"
                required
                value={props.companyName}
                onChange={(e) => props.updateCompanyName(e.target.value)}
                disabled={
                  props.existingIssue && existingSecurityAddress?.length > 0
                    ? true
                    : props?.isManageIssue
                      ? true
                      : false
                }
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Security Symbol</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Security token symbol"
                value={props.isinValue}
                required
                onChange={(e) => props.updateIsinValue(e.target.value)}
                disabled={
                  props.existingIssue && existingSecurityAddress?.length > 0
                    ? true
                    : props?.isManageIssue
                      ? true
                      : false
                }
              />
            </Col>
          </Row>
          {!props?.isManageIssue && (
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Target client</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <DropdownButton
                  id="dropdown-basic-button"
                  title={props.productType}
                >
                  {productType?.map((type, id) => (
                    <Dropdown.Item
                      key={id}
                      onClick={(e) => props.updateProductType(type)}
                    >
                      {type}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
            </Row>
          )}
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Product Category</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <DropdownButton
                id="dropdown-basic-button"
                title={props.productCategory}
              >
                {productCategory?.map(
                  (type, id) =>
                    !MarginIssueCategoryMarkers.includes(type) && (
                      <Dropdown.Item
                        key={id}
                        onClick={(e) => {
                          if (!props.isManageIssue) {
                            props.updateProductCategory(type);
                          }
                        }}
                      >
                        {type}
                      </Dropdown.Item>
                    ),
                )}
              </DropdownButton>
            </Col>
          </Row>
          {!props?.isManageIssue && (
            <>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Underlying Asset Exchange</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title={clickAssestExchange?.toUpperCase()}
                  >
                    {AssetsEchanges?.map((ass, id) => (
                      <Dropdown.Item
                        key={id}
                        onClick={(e) => {
                          setClickAssestExchange(ass?.toLowerCase());
                        }}
                      >
                        {ass?.toUpperCase()}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </Col>
              </Row>
              {!props?.isManageIssue && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 3, offset: 2 }} className="text-left">
                    <b>Underlying Asset</b>
                  </Col>
                  <Col className="pl-0" xs={5}>
                    <DropdownButton
                      id="dropdown-basic-button"
                      title={uderlyingAsset?.name}
                    >
                      {currentItems?.map((ass, id) => (
                        <Dropdown.Item
                          key={id}
                          onClick={(e) => {
                            setUderlyingAsset({
                              name: ass?.shortName,
                              id: ass?.instrumentInternalId,
                            });
                            props.updateIsinValue(ass?.tickerId);
                            props.updateCompanyName(ass?.shortName);
                          }}
                        >
                          {ass?.shortName}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                  </Col>
                </Row>
              )}
            </>
          )}
          {!props?.isManageIssue && (
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Country</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <Select
                  options={supportedCountries.map((country, id) => {
                    return {
                      value: country.name,
                      label: country.name,
                      code: country.code,
                    };
                  })}
                  isMulti={false}
                  value={countryName}
                  onChange={(selected) => {
                    setCountry(selected.code);
                    setCountryName(selected.name);
                  }}
                />
              </Col>
            </Row>
          )}
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Issue manager</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <DropdownButton
                id="dropdown-basic-button"
                title={
                  props.intermediary
                    ? shortAddress(props.intermediary.address)
                    : "Select issue manager"
                }
              >
                {intermediaryList?.map((manager, id) => (
                  <Dropdown.Item
                    key={manager.address}
                    onClick={(e) => {
                      if (!props?.isManageIssue) {
                        props.updateIntermediary(manager);
                      }
                    }}
                  >
                    <b>{manager.name}</b>&nbsp;({shortAddress(manager.address)})
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Col>
          </Row>
          {showCustodian && (
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Custodian</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <DropdownButton
                  id="dropdown-basic-button"
                  title={
                    custodianList
                      ? custodianList.length
                        ? custodian
                          ? shortAddress(custodian)
                          : "Select custodian"
                        : "Select custodian"
                      : null
                  }
                >
                  {custodianList ? (
                    custodianList.length ? (
                      custodianList?.map((manager, id) => (
                        <Dropdown.Item
                          key={manager.address}
                          onClick={(e) => setCustodian(manager.address)}
                        >
                          <b>{manager.name}</b>&nbsp;(
                          {shortAddress(manager.address)})
                        </Dropdown.Item>
                      ))
                    ) : (
                      <span className="p-2">
                        {country ? "No custodian present" : "Select a country"}
                      </span>
                    )
                  ) : null}
                </DropdownButton>
              </Col>
            </Row>
          )}
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Currency denomination</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <DropdownButton
                id="dropdown-basic-button"
                title={
                  currencySupportedList?.find(
                    (data) =>
                      data.tokenAddress?.toLowerCase() ==
                      props.currency?.toLowerCase(),
                  )
                    ? currencySupportedList?.find(
                        (data) =>
                          data.tokenAddress?.toLowerCase() ==
                          props.currency?.toLowerCase(),
                      )?.tokenName
                    : "Select Currency"
                }
              >
                {currencySupportedList?.map((token, id) => (
                  <Dropdown.Item
                    key={id}
                    onClick={(e) => {
                      if (!props?.isManageIssue) {
                        props.updateCurrency(token?.tokenAddress);
                        setSelectedCurrencyToken(token);
                      }
                    }}
                  >
                    {token?.tokenName}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Col>
          </Row>
          {/* <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Offer document</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="ipfs address for offering documents"
                fieldType="file"
                accept=".json,application/json"
                onChange={(e) => retrieveFile(e)}
                required
              />
            </Col>
          </Row> */}
          {!props?.isManageIssue && (
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Restricted Countries</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <Select
                  options={countryDetails.map((cont) => {
                    if (cont.code.toLowerCase() !== country.toLowerCase()) {
                      return {
                        value: cont.name,
                        label: cont.name,
                        code: cont.code,
                      };
                    } else {
                      return {
                        value: "",
                        label: "",
                        code: "",
                      };
                    }
                  })}
                  isMulti
                  value={restrictedCountries}
                  onChange={(selected) => setRestrictedCountries(selected)}
                />
              </Col>
            </Row>
          )}
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Amount</b>
            </Col>
            <Col className="pl-0" xs={5}>
              {!props?.isManageIssue && (
                <TextInput
                  placeholder="Decimals supported"
                  fieldType="number"
                  required
                  onChange={(e) => setAmount(e.target.value)}
                />
              )}
              {props?.isManageIssue && <b>{props?.amount}</b>}
            </Col>
          </Row>

          <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              {!props?.isManageIssue && (
                <UiButton
                  onClick={async () => {
                    if (web3 && signer && account && chainId) {
                      await addIssue();
                    }
                  }}
                  buttonVariant="primary"
                  buttonClass="SignUpButton flex-1 ml-0"
                  buttonText="Create Issue"
                  type="submit"
                />
              )}
              {props?.isManageIssue && (
                <UiButton
                  onClick={async () => {
                    props.updateModalView(3);
                  }}
                  buttonVariant="primary"
                  buttonClass="SignUpButton flex-1 ml-0"
                  buttonText="Create Issue"
                  type="Proceed"
                />
              )}
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export default function AddIssue(props) {
  return <NewIssue {...props} />;
}
